module.exports = __webpack_public_path__ + "img/wohndorf.a54b38c8.jpg";